<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <a class="nav-link" href="#" @click="logout()">
        <span class="no-icon">Log out</span>
      </a>
    </li>
  </ul>
</template>
<script>
  import axios from "axios";
  export default {
    name: 'mobile-menu',
    methods: {
      logout() {
        var self = this
        axios
          .get("/api/logout")
          .then(() => {
            self.$router.push("/")
          })
      }
    }
  }
</script>
<style>
</style>
